/*
 * @Description:: 请补充填写
 * @Version: 请配置版本号
 * @Author: 小白stweet
 * @Date: 2020-06-03 08:12:33
 * @LastEditors: smallWhite
 * @LastEditTime: 2024-06-11 11:40:02
 * @FilePath: /fujian-official-website/src/router.js
 */ 
import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import Index from './views/home/index.vue'
NProgress.configure({
  easing: 'ease',  // 动画方式
  speed: 800,  // 递增进度条的速度
  showSpinner: false, // 是否显示加载ico
  trickleSpeed: 200, // 自动递增间隔
  minimum: 0.5 // 初始化时的最小百分比
})
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path:'/', 
      component: Index, 
      name: 'index',
      meta: {title: '福建省闽西交通工程有限公司-首页'},
    },
    {
    path:'/', 
    component: () => import("./views/main"),
    name: '/',
    children:[
      {
        path:'/company_profile', 
        component: () => import("./views/about_us/about_us"), 
        name: 'company_profile',
        children:[
          {
            path:'/company_profile', 
            component: () => import("./views/about_us/components/company_profile"), 
            name: 'company_profile',
            meta: {title: '关于我们-公司简介'},
          },
          {
            path:'/development_history', 
            component: () => import("./views/about_us/components/development_history"), 
            name: 'development_history',
            meta: {title: '关于我们-发展历程'},
          },{
            path:'/management_team', 
            component: () => import("./views/about_us/components/management_team"), 
            name: 'management_team',
            meta: {title: '关于我们-管理团队'},
          },{
            path:'/leadership_care', 
            component: () => import("./views/about_us/components/leadership_care"), 
            name: 'leadership_care',
            meta: {title: '领导关怀'},
          },
        ]
      },
      {
        path:'/highway_project', 
        component: () => import("./views/yewu/index"), 
        name: 'highway_project',
        children:[
          {
            path:'/highway_project', 
            component: () => import("./views/yewu/components/highway_project"), 
            name: 'highway_project',
            meta: {title: '业务领域-公路工程'},
          },
          {
            path:'/government_project', 
            component: () => import("./views/yewu/components/government_project"), 
            name: 'development_history',
            meta: {title: '业务领域-市政工程'},
          },{
            path:'/bridge_project', 
            component: () => import("./views/yewu/components/bridge_project"), 
            name: 'management_team',
            meta: {title: '业务领域-桥梁工程'},
          },{
            path:'/tunnel_project', 
            component: () => import("./views/yewu/components/tunnel_project"), 
            name: 'tunnel_project',
            meta: {title: '业务领域-隧道工程'},
          },{
            path:'/intellectualization', 
            component: () => import("./views/yewu/components/intellectualization"), 
            name: 'intellectualization',
            meta: {title: '业务领域-工程检测'},
          },
        ]
      },
      {
        path:'/professional_qualification', 
        component: () => import("./views/jishushili/index"), 
        name: 'professional_qualification',
        children:[
          {
            path:'/professional_qualification', 
            component: () => import("./views/jishushili/components/professional_qualification"), 
            name: 'professional_qualification',
            meta: {title: '技术实力-专业资质'},
          },{
            path:'/certificate_of_honor', 
            component: () => import("./views/jishushili/components/certificate_of_honor"), 
            name: 'certificate_of_honor',
            meta: {title: '技术实力-荣誉证书'},
          },{
            path:'/technological_innovation', 
            component: () => import("./views/jishushili/components/technological_innovation"), 
            name: 'technological_innovation',
            meta: {title: '技术实力-技术创新'},
          },
        ]
      },
      {
        path:'/project_way_index', 
        component: () => import("./views/project/index"), 
        name: 'project_way_index',
        children:[
          {
            path:'/project_way_index', 
            component: () => import("./views/project/components/project_way_index"), 
            name: 'project_way_index',
            meta: {title: '项目案例-公路工程'},
          },
          {
            path:'/project_government', 
            component: () => import("./views/project/components/project_government"), 
            name: 'project_government',
            meta: {title: '项目案例-市政工程'},
          },{
            path:'/investment_business', 
            component: () => import("./views/project/components/investment_business"), 
            name: 'investment_business',
            meta: {title: '项目案例-投资业务'},
          },{
            path:'/engineering_inspection', 
            component: () => import("./views/project/components/engineering_inspection"), 
            name: 'engineering_inspection',
            meta: {title: '项目案例-工程检测'},
          },
        ]
      },
      {
        path:'/cultural_concept', 
        component: () => import("./views/qiyewenhua/index"), 
        name: 'cultural_concept',
        children:[
          {
            path:'/cultural_concept', 
            component: () => import("./views/qiyewenhua/components/cultural_concept"), 
            name: 'cultural_concept',
            meta: {title: '企业文化-文化理念'},
          },{
            path:'/safe_production', 
            component: () => import("./views/qiyewenhua/components/safe_production"), 
            name: 'safe_production',
            meta: {title: '企业文化-安全生产'},
          },{
            path:'/craftsman_spirit', 
            component: () => import("./views/qiyewenhua/components/craftsman_spirit"), 
            name: 'craftsman_spirit',
            meta: {title: '企业文化-闽交精神'},
          }
        ]
      },
      {
        path:'/industry_news', 
        component: () => import("./views/news/index"), 
        name: 'industry_news',
        children:[
          {
            path:'/industry_news', 
            component: () => import("./views/news/components/industry_news"), 
            name: 'industry_news',
            meta: {title: '新闻资讯-行业新闻'},
          },{
            path:'/company_news', 
            component: () => import("./views/news/components/company_news"), 
            name: 'company_news',
            meta: {title: '新闻资讯-公司新闻'},
          },{
            path:'/party_building', 
            component: () => import("./views/news/components/party_building"), 
            name: 'party_building',
            meta: {title: '新闻资讯-党建'},
          },{
            path:'/video_news', 
            component: () => import("./views/news/components/video_news"), 
            name: 'video_news',
            meta: {title: '新闻资讯-闽交风采'},
          },{
            path:'/shape', 
            component: () => import("./views/news/components/shape"), 
            name: 'shape',
            meta: {title: '新闻资讯-媒体聚焦'},
          },{
            path:'/news_details', 
            component: () => import("./views/news/components/details"), 
            name: 'news_details',
            meta: {title: '新闻资讯-详情'},
          },
        ]
      },{
        path:'/job_recruitment', 
        component: () => import("./views/rencaizhaopin/index"), 
        name: 'job_recruitment',
        children:[
          {
            path:'/job_recruitment', 
            component: () => import("./views/rencaizhaopin/components/job_recruitment"), 
            name: 'job_recruitment',
            meta: {title: '人才招聘-招聘岗位'},
          },{
            path:'/people_develoment', 
            component: () => import("./views/rencaizhaopin/components/people_develoment"), 
            name: 'people_develoment',
            meta: {title: '人才招聘-人才发展'},
          },{
            path:'/team_building', 
            component: () => import("./views/rencaizhaopin/components/team_building"), 
            name: 'team_building',
            meta: {title: '人才招聘-团队建设'},
          },{
            path:'/team_building_details', 
            component: () => import("./views/rencaizhaopin/components/details.vue"), 
            name: 'team_building_details',
            meta: {title: '人才招聘-团队建设'},
          }
        ]
      },
      {
        path:'/contact_us', 
        component: () => import("./views/contact_us/index"), 
        name: 'contact_us',
        meta: {title: '联系我们'},
      }
    ]
  },
    { path: '*', redirect: '/' }
  ],
  mode: 'history'
})
router.beforeEach((to,from,next) => {
  
  if(from.name === null && to.name === 'index'){
    store.commit('setOpenNav', [0,0])
    NProgress.start();
    next()
  }else{
    NProgress.start();
    next()
  }
})
router.afterEach(() => {
  // 在即将进入新的页面组件前，关闭掉进度条
  NProgress.done()
})
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

export default router